<div class="content">
    <form [formGroup]="form" (ngSubmit)="onSubmit()">
        <p class="center title-text">Wachtwoord vergeten?</p>
        <mat-dialog-content>
            <p>Vul uw e-mail adres in om het wachtwoord te veranderen</p>
            <mat-form-field style="width: 100%;">
                <input matInput type="email" placeholder="E-mail adres" formControlName="email">
            </mat-form-field>
            <p class="error-message" *ngIf="status">
                <mat-icon>error_outline</mat-icon> {{ status }}
            </p>
        </mat-dialog-content>
        <mat-dialog-actions>
            <div>
                <a mat-button (onClick)="onNoClick()">Annuleren</a> 
                <button class="accept-button" mat-button type="submit" [disabled]="!form.valid">Accepteren</button>
            </div>
        </mat-dialog-actions>
    </form>

</div>